let navEl;
const submenus = {};
const buttons = {};
let controls;

function handleClick(event) {
  event.preventDefault();

  const buttonEl = event.currentTarget;
  const buttonControls = buttonEl.getAttribute('aria-controls').split(' ');
  const submenuEl = navEl.querySelector(`#${buttonControls[0]}`);
  const isExpanded = buttonEl.getAttribute('aria-expanded') === 'true';

  const currentLevel = parseInt(buttonEl.dataset.level, 10);

  [...buttons[currentLevel]].forEach((el) => { el.setAttribute('aria-expanded', 'false'); });
  [...submenus[currentLevel]].forEach((el) => { el.setAttribute('aria-hidden', 'true'); });

  buttonEl.setAttribute('aria-expanded', !isExpanded);
  submenuEl.setAttribute('aria-hidden', isExpanded);
}

function handleClickOutside() {
  document.addEventListener('click', (event) => {
    // submenu wrapper
    const topbarEl = document.querySelector('header.top-bar');
    const isClickInside = topbarEl.contains(event.target);
    if (isClickInside) {
      return false;
    }
    // outside click is happened. Close all open submenus
    const submenuButtonsEls = topbarEl.querySelectorAll('[aria-expanded="true"]');
    const submenuWrapperEls = topbarEl.querySelectorAll('[aria-hidden="false"]');
    [...submenuButtonsEls].forEach((el) => { el.setAttribute('aria-expanded', 'false'); });
    [...submenuWrapperEls].forEach((el) => { el.setAttribute('aria-hidden', 'true'); });
    return true;
  });
}

function init() {
  navEl = document.querySelector('.nav-desktop');

  if (navEl) {
    submenus[1] = navEl.querySelectorAll('.menu__submenu.level-1');
    submenus[2] = navEl.querySelectorAll('.menu__submenu.level-2');
    submenus[3] = navEl.querySelectorAll('.menu__submenu.level-3');
    buttons[1] = navEl.querySelectorAll('.menu__toggle.level-1');
    buttons[2] = navEl.querySelectorAll('.menu__toggle.level-2');
    buttons[3] = navEl.querySelectorAll('.menu__toggle.level-3');

    controls = navEl.querySelectorAll('[aria-controls]');

    [...controls].forEach((el) => { el.addEventListener('click', handleClick); });
  }

  handleClickOutside();
}

export default {
  init,
};
